
import {
  defineComponent,
  PropType,
} from '@vue/composition-api';
import { LinkButton } from '@fc/angie-ui';

type ContentPosition = 'top' | 'center' | 'bottom';

/**
 * HeroSection component for full-screen hero sections with video/image backgrounds.
 *
 * @example Single CTA (using props - backward compatible)
 * <HeroSection
 *   title="We Choose"
 *   title-second-line="Hard"
 *   subtitle="Real boxing & Martial Arts coaching."
 *   cta-text="Start Training"
 *   cta-link="/shop"
 *   video-url="https://example.com/video.mp4" />
 *
 * @example Multiple CTAs (using slot)
 * <HeroSection
 *   title="We Choose"
 *   title-second-line="Hard"
 *   subtitle="Real boxing & Martial Arts coaching.">
 *   <template #cta>
 *     <FCButton button-size="large" button-theme="button-primary">
 *       Start Training
 *     </FCButton>
 *     <LinkButton
 *       cta-text="Learn More"
 *       button-theme="button-outline"
 *       mode="dark" />
 *   </template>
 * </HeroSection>
 *
 * @example With static height (prevents mobile Safari shifting)
 * <HeroSection
 *   title="We Choose Hard"
 *   subtitle="Real boxing & Martial Arts coaching."
 *   use-static-height
 *   image-url="https://example.com/hero.jpg" />
 */
export default defineComponent({
  name: 'HeroSection',
  components: {
    LinkButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    titleSecondLine: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      required: true,
    },
    ctaText: {
      type: String,
      default: '',
    },
    ctaLink: {
      type: String,
      default: '',
    },
    ctaTheme: {
      type: String,
      default: 'button-outline',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    videoUrl: {
      type: String,
      default: '',
    },
    mobileVideoUrl: {
      type: String,
      default: '',
    },
    contentPosition: {
      type: String as PropType<ContentPosition>,
      default: 'center' as ContentPosition,
      validator: (value: string) => ['top', 'center', 'bottom'].includes(value),
    },
    useStaticHeight: {
      type: Boolean,
      default: false,
    },
    tagline: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {};
  },
});
